module.exports = __webpack_public_path__ + "img/Lady_lock.c6e62600.svg";